import { useState, useCallback } from "react";
import { AgGrid } from "@jsq/ds/core";

export const useSlideoutDrawer = () => {
  const [userId, setUserId] = useState<string | undefined>(undefined);

  const onRowClicked = useCallback((event: AgGrid.RowClickedEvent) => {
    setUserId(event.data.id.toString());
  }, []);

  const onClose = useCallback(() => {
    setUserId(undefined);
  }, []);

  return { userId, onClose, onRowClicked, setUserId };
};
